import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';
import { Table, TableHeader, TableRow } from 'component/Table';
import { InfoItem } from 'component/InfoItem';
import { isLegacyLandWaterView } from 'utils/HaReportFormVersion';

export const IndirectBeneficiariesView = (props) => {
  const { formData } = props;
  const beneficiaries = formData.info.landuse_and_beneficiaries;
  const isLegacy = isLegacyLandWaterView(formData);

  return (
    <>
      <div className="flex-column-group">
        <AccordionBodyItem
          accordionSubId=""
          titleUA="Кількість непрямих бенефіціарів"
          titleEN="Number of indirect beneficiaries"
        />
        <Table>
          <TableHeader>
            <th>
              <div>{isLegacy ? '8.12' : '8.13'} Чоловіків (18 та старше)</div>
              <div>Men (18+)</div>
            </th>
            <th>
              <div>{isLegacy ? '8.13' : '8.14'} Жінок (18 та старше)</div>
              <div>Women (18+)</div>
            </th>
            <th>
              <div>{isLegacy ? '8.14' : '8.15'} Хлопчиків (молодше 18)</div>
              <div>Boys</div>
            </th>
            <th>
              <div>{isLegacy ? '8.15' : '8.16'} Дівчаток (молодше 18)</div>
              <div>Girls</div>
            </th>
          </TableHeader>
          <tbody>
            <TableRow>
              <td>{beneficiaries.number_of_indirect_beneficiaries?.men || 0}</td>
              <td>{beneficiaries.number_of_indirect_beneficiaries?.women || 0}</td>
              <td>{beneficiaries.number_of_indirect_beneficiaries?.boys || 0}</td>
              <td>{beneficiaries.number_of_indirect_beneficiaries?.girls || 0}</td>
            </TableRow>
          </tbody>
        </Table>
      </div>
      <div
        className="flex-right"
        style={{ marginTop: '10px', paddingBottom: '10px' }}
      >
        <InfoItem
          titleEN="Total number of indirect beneficiaries"
          titleUA={`${isLegacy ? '8.16' : '8.17'} Загальна кількість непрямих бенефіціарів`}
          data={beneficiaries.number_of_indirect_beneficiaries
            ? Object.values(beneficiaries.number_of_indirect_beneficiaries)
              .reduce((acc, item) => Number(acc) + Number(item))
            : 0}
        />
      </div>
    </>
  );
};
